import { ReactNode } from "react"
import { Button, ButtonProps } from "@chakra-ui/react"
import { useSwitchChain } from "wagmi"

import { selectHasExpectedChain, useDappSelector } from "#/redux-state"

type SwitchChainButtonProps = ButtonProps & {
  label?: ReactNode
  chainId: number
}

export default function SwitchChainButton({
  label,
  chainId,
  ...props
}: SwitchChainButtonProps) {
  const hasCorrectChain = useDappSelector((state) =>
    selectHasExpectedChain(state, chainId),
  )

  const { switchChain } = useSwitchChain()

  if (hasCorrectChain) return null

  return (
    <Button
      type="submit"
      variant="primary"
      size={{ base: "medium", xl: "large" }}
      h="64px"
      {...props}
      onClick={() => switchChain({ chainId })}
    >
      {label ? `Switch chain to ${label}` : "Switch chain"}
    </Button>
  )
}
